import React from 'react';
export function Testimonials() {
  return <div className="max-w-3xl mx-auto px-4 py-4" data-id="element-230">
      <h2 className="text-xl font-bold mt-10 mb-6" data-id="element-231">
        Real Dog Owners, Real Results
      </h2>

      <div className="bg-gray-50 p-6 rounded-lg mb-6 border border-gray-200" data-id="element-232">
        <div className="flex items-start mb-4" data-id="element-233">
          <div className="flex-grow" data-id="element-234">
            <div className="text-yellow-500 mb-1" data-id="element-235">★★★★★</div>
            <p className="italic" data-id="element-236">
              "After years of failed brushing attempts, my dog's teeth are
              finally clean. The tartar just started falling off. I can't
              believe it was this simple."
            </p>
            <p className="mt-2 font-semibold" data-id="element-237">
              — Jennifer R., Golden Retriever Mom
            </p>
          </div>
        </div>
      </div>

      <div className="my-8" data-id="element-238">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/szJ2hKVYjKoWsBy3YAvDq1/WhatsApp_Image_2025-11-30_at_23.56.05_e4853227.jpg" alt="Dog owner bonding with their healthy, happy dog" className="w-full h-auto rounded-lg shadow-md" data-id="element-239" />
        <p className="text-center text-sm text-gray-500 mt-2" data-id="element-240">
          The bond between you and your dog gets stronger when they're healthy
        </p>
      </div>

      <div className="bg-gray-50 p-6 rounded-lg mb-6 border border-gray-200" data-id="element-241">
        <div className="flex items-start mb-4" data-id="element-242">
          <div className="flex-grow" data-id="element-243">
            <div className="text-yellow-500 mb-1" data-id="element-244">★★★★★</div>
            <p className="italic" data-id="element-245">
              "My vet actually asked what I was doing differently. Saved me $900
              on a dental cleaning. This stuff works."
            </p>
            <p className="mt-2 font-semibold" data-id="element-246">— Marcus T., Beagle Dad</p>
          </div>
        </div>
      </div>

      <div className="my-8" data-id="element-247">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6UuxLzXkqyNb4aZGQfGunz/WhatsApp_Image_2025-11-30_at_23.50.01_50a94f70.jpg" alt="Dog at veterinary clinic getting a checkup" className="w-full h-auto rounded-lg shadow-md" data-id="element-248" />
        <p className="text-center text-sm text-gray-500 mt-2" data-id="element-249">
          Regular vet visits become easier when your dog's teeth are healthy
        </p>
      </div>

      <div className="bg-gray-50 p-6 rounded-lg mb-6 border border-gray-200" data-id="element-250">
        <div className="flex items-start mb-4" data-id="element-251">
          <div className="flex-grow" data-id="element-252">
            <div className="text-yellow-500 mb-1" data-id="element-253">★★★★★</div>
            <p className="italic" data-id="element-254">
              "No more death breath! My dog actually drinks more water now. I
              add it every morning and forget about it."
            </p>
            <p className="mt-2 font-semibold" data-id="element-255">— Amanda K., Rescue Dog Mom</p>
          </div>
        </div>
      </div>
    </div>;
}